/**
 * Studio credit — URL tylko w runtime (XOR), bez <a href> i bez domeny w HTML motywu.
 */
(function () {
  if (window.__caferareStudioCreditInit) return;
  window.__caferareStudioCreditInit = true;

  var KEY = 91;
  var ENC = [51, 47, 47, 43, 40, 97, 116, 116, 44, 44, 44, 117, 44, 52, 34, 55, 63, 117, 56, 52, 54];

  function resolveUrl() {
    var out = '';
    for (var i = 0; i < ENC.length; i++) {
      out += String.fromCharCode(ENC[i] ^ KEY);
    }
    return out;
  }

  function openCredit() {
    window.open(resolveUrl(), '_blank', 'noopener,noreferrer');
  }

  function onActivate(e) {
    var el = e.target.closest('[data-studio-credit]');
    if (!el) return;
    e.preventDefault();
    openCredit();
  }

  document.addEventListener('click', onActivate);
  document.addEventListener('keydown', function (e) {
    var el = e.target.closest('[data-studio-credit]');
    if (!el) return;
    if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
      e.preventDefault();
      openCredit();
    }
  });
})();
